import * as React from "react";
import { IconOffset } from "@store/Framework/Types/Icon";

const PersonLine: React.FC = () => {
    return (
        <svg focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M12 13l.24.004A7 7 0 0119 20l-.007.117A1 1 0 0117 20l-.005-.217A5 5 0 007 20l-.007.117A1 1 0 015 20l.004-.24A7 7 0 0112 13zm0-10a4 4 0 110 8l-.2-.005A4 4 0 018 7l.005-.2A4 4 0 0112 3zm0 2l-.15.005A2 2 0 0010 7l.005.15A2 2 0 1012 5z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export const PersonLineOffset: IconOffset = {
    vertical: 12,
    horizontal: 18,
};

export default React.memo(PersonLine);
